import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import * as actions from '../../actions/ticket-action';
import { useDispatch } from 'react-redux';
import * as service from '../../services/sTicket/ticket.service';
import { t } from 'i18next';
import { propTypes } from 'react-bootstrap/esm/Image';
import { Icon } from '@fluentui/react';

const TableItem = ({ tableItem, handleEditFormOpen, handleAnswerFormLoad }) => {

  const dispatch = useDispatch();

  const handleDeleteItem = () => {
    const theId = tableItem.id;
    
    service.deleteTicket(theId).then(async (response) => {
      const deletedItem = response.data.data; 
      if(deletedItem)     
        dispatch(actions.deleteItem(theId));

    }).catch(() => {

    });
  };

  const handleEditClick = () => {
    handleEditFormOpen(tableItem);
  };

  const handleAnswersClick = () => {
    handleAnswerFormLoad(tableItem);
  };

  const handleTrClass = (update, status) => {
    let trClassName;
    if (update) {
      trClassName = 'update';
      if (status === 'Closed') {
        trClassName = 'update closed';
      }
    }
    return trClassName;
  };


  const priorityClass = classNames('badge bg-pill', {
    'bg-secondary': tableItem.priority === 'Normal',
    'bg-success': tableItem.priority === 'Low',
    'bg-warning': tableItem.priority === 'Medium',
    'bg-danger': tableItem.priority === 'High',
  });

  const statusClass = classNames('badge bg-pill', {
    'bg-primary': tableItem.status === 'Open',
    'bg-warning': tableItem.status === 'Pending',
    'bg-success': tableItem.status === 'Processing',
    'bg-light': tableItem.status === 'Closed',
  });

  return (
    <tr className={handleTrClass(tableItem.update, tableItem.status)}>
      <td>
        <span>{tableItem.id}</span>
      </td>
      <td>
        <span>{tableItem.subject}</span>
      </td>
      <td>
        <span>{tableItem.category}</span>
      </td>
      <td>
        <span>{tableItem.assignee}</span>
      </td>
      <td>
        <span>{tableItem.creation_date}</span>
      </td>
      <td>
        <span className={priorityClass}>{tableItem.priority}</span>
      </td>
      <td>        
        <span className={statusClass}>{tableItem.status}</span>
      </td>
      <td>
        <span>{tableItem.answers_number}</span>
      </td>
      <td>
        <span>{tableItem.has_docs && <Icon iconName='Attach' style={{paddingBottom: "10px", fontSize: "16px", fontFamily: "FabricMDL2Icons"}} />}</span>
      </td>
      <td className='text-end'>
      <button
          type="button"
          className="btn btn-outline-info btn-sm mr-2 info-btn"
          onClick={handleAnswersClick}
        >
          Answers
        </button>
        <button
          type="button"
          className="btn btn-outline-dark btn-sm mr-2 edit-btn"
          onClick={handleEditClick}
        >
          Edit
        </button>
        <button
          type="button"
          className="btn btn-outline-danger btn-sm delete-btn"
          onClick={handleDeleteItem}
        >
          Delete
        </button>
      </td>
    </tr>
  );
};

TableItem.propTypes = {
  tableItem: PropTypes.shape({
    id: PropTypes.number,
    subject: PropTypes.string,
    category: PropTypes.string,
    assignee: PropTypes.string,
    priority: PropTypes.string,
    status: PropTypes.string,
    update: PropTypes.bool,
    creation_date: PropTypes.string,
    answers_number: PropTypes.number,
    has_docs: PropTypes.bool
  }),

};

TableItem.defaultProps = {
  tableItem: {
    id: 1,
    subject: 'A new rating has been received',
    category: 'Marketing',
    assignee: 'Erwin',
    priority: 'Medium',
    status: 'Open',
    update: false,
    creation_date: '',
    answers_number: 0,
    has_docs: false
  },
};

export default TableItem;
